import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  ...stateAbstract,
  intentCustomer: {},
  intentsDetail: {},
  linksDetail: {},
  linksAmount: null
}

const actions = {
  SET_LINK_AMOUNT: ({ commit }, { amount }) => {
    commit('SET_LINK_AMOUNT', { amount })
  },
  SET_INTENT_CUSTOMER: ({ commit }, { customer }) => {
    commit('SET_INTENT_CUSTOMER', { customer })
  },
  ...actionsAbstract
}

const mutations = {
  SET_LINK_AMOUNT: (state, { amount }) => {
    state.linksAmount = amount
  },
  SET_INTENT_CUSTOMER: (state, { customer }) => {
    state.intentCustomer = customer
  },
  ...mutationsAbstract
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
